<template>
    <v-container fluid class="fill-height">
    <v-snackbar
      v-model="snackbarVerify"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
        >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbarVerify = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar" top color="red">
        <span>{{errMsg}}</span> 
        <v-btn text color="white" @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarcopy" top color="green">
        <span>{{copyMsg}}</span> 
        <v-btn text color="white" @click="snackbarcopy = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="successDeposit" max-width="500">
        <v-card class="pa-7" color="#e0e0e0" >
            <v-card-text class="text-center">
                <v-avatar color="white" size="90" class="mt-n3">
                    <v-icon :color="iconColor" x-large>{{icon}}</v-icon>
                </v-avatar>
            </v-card-text>
            <v-card-text class="text-center black--text">{{iconMessage}}</v-card-text>
            <!-- <v-card-text class="font-weight-bold black--text">Amount: {{amount}}</v-card-text> -->
            <v-card-text class="font-weight-bold black--text">BTC Address: {{depositAddress}}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="successDeposit=false">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <v-card flat class="px-2 mx-auto" id="login" max-width="500px">
                   
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div class=" white--text text-center mr-2"  style="width:40%; border:3px #e0e0e0 solid">
                            <h3 class="text-center grey--text ma-0 pa-0">USD BALANCE</h3>
                            <p class="text-center green--text font-weight-bold ma-0 pa-0"> {{parseFloat(wallet.walletBalanceUsd).toFixed(2)}} </p>
                        </div>
                        <div class=" white--text text-center mr-2"  style="width:40%; border:3px #e0e0e0 solid">
                            <h3 class="text-center grey--text ma-0 pa-0">BTC BALANCE</h3>
                            <p class="text-center green--text font-weight-bold ma-0 pa-0"> {{parseFloat(wallet.walletBalanceBtc).toFixed(8)}} </p>
                        </div>
                        <v-spacer></v-spacer>
                        
                        
                    </v-card-actions>
                    <v-card-text class="text-center mt-12">
                        <v-btn small rounded text style="border:1px orange solid; width:50%" class="ma-2 text-none">
                            <v-icon class="orange--text">mdi-bitcoin</v-icon>
                            <span class="orange--text">BTC Wallet</span>
                        </v-btn>
                        <p class="green--text font-weight-bold">{{parseFloat(wallet.walletBalanceBtc).toFixed(8)}} BTC ({{parseFloat(wallet.walletBalanceUsd).toFixed(2)}} USD) AVAILABLE</p>
                        <p class="grey--text font-weight-bold">{{parseFloat(wallet.escrowWalletBtc).toFixed(8)}} BTC ({{parseFloat(wallet.escrowWalletUsd).toFixed(2)}} USD) IN ESCROW</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text  class="font-weight-bold ma-2"  style="width:30%; border:1px blue solid" to="/wallet/withdraw" :disabled="disabled">
                            WITHDRAW
                        </v-btn>
                        <v-btn :color="color" :loading="load" class="font-weight-bold ma-2" style="width:30%" @click="deposit()" :disabled="disabled">
                            DEPOSIT
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>

                    <v-card-text class="text-center" v-if="copyclip===true" >
                        
                        <!-- <v-img src="/serverdown.png" height="100px" width="100px" contain class="mx-auto" style="border:1px grey solid"></v-img> -->
                        <v-card-text class="grey--text font-weight-bold">BTC ADDRESS</v-card-text>
                        <v-card-text>
                        <h3 class="black--text">{{depositAddress}}</h3>
                        <v-btn
                            color="green" small dark
                            v-clipboard:copy='depositAddress'
                            v-clipboard:success='onCopy'
                            v-clipboard:error='onError' class="mx-5 mt-2">Copy!</v-btn>
                        </v-card-text>
                    </v-card-text>
                    <!-- <v-card-text class="text-center" v-if="isDeposit===true">
                        
                        
                        <v-form>
                            <v-text-field class="mx-auto mb-n5" outlined v-model="depositAddress" type="text" color="blue" dense style="width:90%" label="BTC Address to pay to" readonly></v-text-field>
                            <v-text-field class="mx-auto mt-4 mb-n5" outlined v-model="amount" type="number" color="blue" dense style="width:90%" label="Deposit Amount in BTC" autofocus suffix="BTC"></v-text-field>
                            <v-text-field class="mx-auto mt-4" outlined v-model="senderAddress" type="text" color="blue" dense style="width:90%" label="BTC Address to pay from"></v-text-field>
                        </v-form>
                        <v-btn dark color="blue" style="width:70%" :loading="loading" @click="depositFunds()">DEPOSIT FUNDS</v-btn>
                    </v-card-text> -->
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    data(){
        return{
            snackbarVerify:false,
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
            isDeposit:false,
            loading:false,
            load:false,
            color:'grey',
            successDeposit:false,
            iconColor:'',
            icon:'',
            iconMessage:'',
            snackbar:false,
            snackbarcopy:false,
            copyMsg:'',
            errMsg:'',
            amount:'',
            senderAddress:'',
            copyclip: false,
            disabled: false
        }
    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
    },
    computed:{
        wallet(){
            return this.$store.state.auth.logindetails
        },
        depositAddress(){
            if(this.$store.state.wallet.DepositAddress.data){
                return this.$store.state.wallet.DepositAddress.data.address

            }else{
                return ''
            }
            // return '3BMvwvXAFcxMHCLqGhdXGhJM45wTe5y5NT'
        }
    },
    methods:{
        deposit(){
            if(this.isDeposit==true){
                this.color='grey'
                this.isDeposit=false
            }else{
                this.load=true
                this.color='green'
                
                this.$store.dispatch("DepositFunds")
                .then((success)=>{
                    console.log(success)
                    this.load = false
                    this.isDeposit=true
                    this.icon = 'mdi-check-bold'
                    this.iconColor= 'green'
                    this.iconMessage= `Make a deposit to this BTC Address:${this.depositAddress}. NOW! Click 'Ok' and copy the link`
                    this.successDeposit = true
                    this.isDeposit = false
                    this.copyclip = true
                    this.disabled=false
                })
                .catch((error)=>{
                    this.load = false
                    this.color='grey'
                    let msg = error.response.data.message
                    this.errMsg = msg.toUpperCase()
                    this.snackbar = true   
                })
            }
            
        },
        depositFunds(){
            this.disabled= true
            this.loading = true
            this.$store.dispatch("DepositFunds",{
                "amountBtc":this.amount,
                "receiverAddress":this.depositAddress,
                "senderAddress": this.senderAddress
            })
            .then(()=>{
                this.loading=false
                this.icon = 'mdi-check-bold'
                this.iconColor= 'green'
                this.iconMessage= `Make a deposit of  ${this.amount} to the Address:${this.depositAddress}. NOW! `
                this.successDeposit = true
                this.isDeposit = false
                this.copyclip = true
                this.disabled=false
            })
            .catch((error)=>{
                this.loading = false
                this.icon = 'mdi-close'
                this.iconColor= 'red'
                let msg = error.response.data.message
                this.iconMessage = msg.toUpperCase()
                this.successDeposit = true    
                this.disabled= false
            })
        },
        onCopy: function () {
            this.copyMsg = 'Copied to clipboard!'
            this.snackbarcopy = true
        },
        onError: function () {
            this.copyMsg = 'Not Copied'
            this.snackbarcopy = true
        }
    }
}
</script>